var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PatientHeader',{ref:"pheader"},[(_vm.isLoadedMaster)?_c('router-view',{attrs:{"pheader":_vm.pheader}}):_vm._e()],1),_c('AppLoadingDialog',{staticStyle:{"z-index":"1000"},attrs:{"loading":!_vm.isLoadedMaster}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }